module.exports = __webpack_public_path__ + "static/media/dog-alaskan-malamute.371ec0f7.png";